/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    popupStyle: Object,
    value: Boolean,
    goodsName: String,
    noTitle: {
      type: Boolean,
      "default": false
    },
    title: String
  },
  data: function data() {
    return {};
  },
  watch: {},
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    hide: function hide() {
      this.$emit('input', false);
    }
  }
};